import ContactFieldRender from '../ContactFieldRender'
import Globals from '../../Globals'
import UrlWrap from '../UrlWrap'

const Layout = (props) => {
    return (
        <div className="wrap layout1">
            <div>
                <div className="personWrap">
                    <ContactFieldRender name="name" field={props.fields.name} />
                    <ContactFieldRender
                        name="jobTitle"
                        field={props.fields.jobTitle}
                    />

                    <ContactFieldRender
                        name="pronouns"
                        field={props.fields.pronouns}
                    />

                    <div className="contactDetails">
                        {props.contactFields.map((value, index) => {
                            return (
                                <ContactFieldRender key={index} field={value} />
                            )
                        })}

                        <ContactFieldRender
                            name="email"
                            field={props.fields.email}
                        />
                    </div>
                </div>

                <div className="companyWrap">
                    <ContactFieldRender
                        name="company"
                        field={props.fields.company}
                    />

                    <ContactFieldRender
                        name="address"
                        field={props.fields.address}
                    />
                    <div className="urlWrap">
                        <ContactFieldRender
                            name="url"
                            field={props.fields.website}
                        />
                    </div>

                    <div className="logo">
                        <UrlWrap url={props.fields.website.url}>
                            <img
                                alt={props.fields.company.value}
                                src={Globals.logo}
                            />
                        </UrlWrap>
                    </div>
                </div>
            </div>

            <div className="footerWrap">
                <ContactFieldRender
                    name={'bottom'}
                    field={props.fields.bottom}
                />
            </div>
        </div>
    )
}

export default Layout
